import React, { FunctionComponent } from "react";
import { BaseError } from "../../types/errors/AllBrightError";
import RxError from "@/components/ui/display/RxError";

interface ErrorMessageProps {
  error: BaseError;
}

const ErrorMessage: FunctionComponent<ErrorMessageProps> = (props) => {
  return <RxError message={props.error.message} />;
};

export default ErrorMessage;
